// Mutations
export const RESETATTENDANCE = 'RESETATTENDANCE'
export const REMOVEATTENDANCEPLAYER = 'REMOVEATTENDANCEPLAYER'
export const SHOWATTENDANCE = 'SHOWATTENDANCE';
export const HIDEATTENDANCE = 'HIDEATTENDANCE';

const ADDPLAYERTOATTENDANCE = 'ADDPLAYERTOATTENDANCE'

// Actions
export const ADDATTENDANCEPLAYER = 'ADDATTENDANCEPLAYER'
export const LOADLOCKOUTINTOATTENDANCE = 'LOADLOCKOUTINTOATTENDANCE'

import db from '../../firebase/firebase'
import {
  compareEvents } from '../../functions/raideventfunctions'
import {
  compareMarking,
  getSignupAttendanceMarking } from '../helpers/attendance'

export default {
  state: () => ({
    attendanceVisible: false,
    attendancePlayers: [],
  }),

  getters: {
    
  },

  mutations: {
    [RESETATTENDANCE] ( state ) {
      state.attendancePlayers = []
      // state.attendanceVisible = false // don't, we don't want to hide the window when clearing
    },
    
    [ADDPLAYERTOATTENDANCE] ( state, player ) {
      state.attendancePlayers.push( player );
    },
    [REMOVEATTENDANCEPLAYER] ( state, player ) {
      state.attendancePlayers.splice(
        state.attendancePlayers.findIndex( p => p.playerid == player.playerid ),
        1 )
    },

    [SHOWATTENDANCE] ( state ) {
      state.attendanceVisible = true;
    },
    [HIDEATTENDANCE] ( state ) {
      state.attendanceVisible = false;
    },
  },

  actions: {
    async [ADDATTENDANCEPLAYER] ( { state, commit, rootState, rootGetters }, { playerid, name, spec } ) {
      if( !state.attendancePlayers.find( p => p.playerid == playerid ) ) {
        let player = { playerid: playerid,
                       name: name }

        let snapshot = await db.ref( 'destinationAttendance/' +
                                     rootState.destinations.selectedDestination['.key'] +
                                     '/' + playerid ).get()
        
        let classesAttendance = snapshot.val()
        
        player.classes = []
        if( classesAttendance ) {
          // Place mapping in array
          for( let classElement in classesAttendance ) {
            player.classes.push( { name: classElement,
                                   lockouts: classesAttendance[ classElement ] } )
          }
        }
        else {
          // Make sure at least the source spec is listed
          // this way in the visualization, it's not empty
          player.classes.push( { name: rootGetters.getSpecClass( spec ), lockouts: {} } )
        }

        commit( ADDPLAYERTOATTENDANCE, player )
      }
    },
    async [LOADLOCKOUTINTOATTENDANCE] ( { rootState, rootGetters }, lockout ) {

      // Destination to store data in
      let destRef = 'destinationAttendance/' +
                    rootState.destinations.selectedDestination['.key'] + '/';

      // Remove all records for this lockout (traverse over players)
      let playersSnapshot = await db.ref( destRef ).get()
      let players = playersSnapshot.val()
      let removals = {}

      for( let playerkey in players ) {
        let player = players[ playerkey ]

        for( let classname in player ) {
          let classobj = player[ classname ]

          for( let lockoutKey in classobj ) {
            if( lockoutKey == lockout['.key'] ) {
              removals[ playerkey + '/' + classname + '/' + lockoutKey ] = null
            }
          }
        }
      }
      await db.ref( destRef ).update( removals )

      // Fetch all signups for this lockout (convert to array )
      let signupSnapshot = await db.ref( 'lockouts/' + lockout['.key'] + '/signups' ).get()
      let signupsObject = signupSnapshot.val()
      let signups = []
      for( let signupKey in signupsObject ) {
        let signup = signupsObject[ signupKey ]
        Object.defineProperty( signup, '.key', { value: signupKey, enumerable: false } )
        if( !signup.absent ) {
          signups.push( signup )
        }
      }

      // Fetch raidevents for this lockout (convert to array)
      let raideventsSnapshot = await db.ref( 'lockouts/' + lockout['.key'] + '/raidevents' ).get()
      let raideventsObject = raideventsSnapshot.val()
      let raidevents = []
      for( let eventid in raideventsObject ) {
        let raidevent = raideventsObject[ eventid ]
        Object.defineProperty( raidevent, '.key', { value: eventid, enumerable: false } )
        raidevents.push( raidevent )
      }
      raidevents.sort( compareEvents )

      // Get a list of unique players from the signups
      let playerids = signups.map( signup => signup.playerid )
                             .filter( ( playerid, i, array ) => array.indexOf( playerid ) == i )
 
      // Fill updates-object to send to db, holding attendance info
      let updates = {}
      // Iterate over the players
      for( let playerid of playerids ) {

        let playersignups = signups.filter( signup => signup.playerid == playerid )

        // Iterate over the (unique) classes this player has signed as
        let classes = playersignups.map( signup => rootGetters.getSpecClass( signup.spec ) )
                                   .filter( ( clas, i, array ) => array.indexOf( clas ) == i )
        for( let clas of classes ) {

          let attendance = ''
          // Iterate over the events
          for( let raidevent of raidevents ) {
  
            // Get the markings for this player for this event for this spec
            // By first getting the signups, then the markings, then sorting them
            // This way if a character signed more than once from the same spec
            // we get the most 'important' one (Attendance > Bench, etc)
            let markings = playersignups.filter( s => rootGetters.getSpecClass( s.spec ) == clas
                                                      && s.eventid == raidevent['.key'] )
                                        .map( s => getSignupAttendanceMarking( s ) )
                                        .sort( compareMarking )
            if( markings.length > 0 ) {
              attendance += markings[0]
            }
            else {
              attendance += '_'
            }
          }
  
          let playerspecRef = destRef + playerid + '/' + clas + '/' + lockout['.key']
          updates[ playerspecRef ] = attendance
        }
      }

      // Mark lockout as up-to-date (for attendance overview)
      updates[ 'destinationLockouts/' + rootState.destinations.selectedDestination['.key'] +
                '/lockouts/' + lockout['.key'] +
                '/uptodateattendanceoverview' ] = true

      return db.ref().update( updates )
    },
  },
}